module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('data-table', {
    ref: "siteWorkflow",
    attrs: {
      "table-ref": "siteWorkflowTable",
      "title": "Site Workflows",
      "icon": "fa fa-tasks",
      "url": _vm.url,
      "sort-field": "id",
      "fields": _vm.listFields,
      "show-search": false,
      "detail-component": "site-workflow-details",
      "add-action": _vm.isSiteManager ? _vm.addActionComp : null,
      "add-props": _vm.addProps
    },
    scopedSlots: _vm._u([{
      key: "tasks",
      fn: function(props) {
        return [_c('el-card', {
          attrs: {
            "body-style": {
              backgroundColor: '#F2F6FC',
              paddingLeft: '1.2em',
              paddingRight: '1.2em'
            },
            "shadow": "hover"
          }
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 20
          }
        }, [_c('center', [_c('big', {
          staticClass: "text-info"
        }, [(props.rowData.type) ? _c('i', [_vm._v(_vm._s(props.rowData.type) + ": ")]) : _vm._e(), _vm._v(" "), _c('span', {
          staticClass: "text-success"
        }, [_vm._v(_vm._s(props.rowData.name))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_c('span', {
          staticClass: "text-primary"
        }, [_vm._v(_vm._s(props.rowData.site.siteName))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(props.rowData.site.siteId))])])], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 4,
            "align": "right"
          }
        }, [(props.rowData.percentComplete <= 0) ? _c('el-button', {
          attrs: {
            "type": "success",
            "size": "mini",
            "round": "",
            "icon": "fa fa-caret-right"
          },
          on: {
            "click": function($event) {
              return _vm.showDetail(props.rowData.id)
            }
          }
        }, [_vm._v("Start")]) : _vm._e(), _vm._v(" "), (props.rowData.percentComplete >= 1 && props.rowData.percentComplete < 100) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "plain": "",
            "round": "",
            "icon": "fa fa-spinner fa-spin"
          },
          on: {
            "click": function($event) {
              return _vm.showDetail(props.rowData.id)
            }
          }
        }, [_vm._v("In Progress")]) : _vm._e(), _vm._v(" "), (props.rowData.percentComplete === 100) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary",
            "round": "",
            "icon": "fa fa-check-double"
          },
          on: {
            "click": function($event) {
              return _vm.showDetail(props.rowData.id)
            }
          }
        }, [_vm._v("Completed")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
          attrs: {
            "span": 20
          }
        }, [_c('el-progress', {
          attrs: {
            "percentage": parseFloat(props.rowData.percentComplete),
            "text-inside": true,
            "stroke-width": 18,
            "color": props.rowData.percentComplete === 100 ? '#90EE90' : '#87CEEB'
          }
        })], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "align": "right",
            "span": 4
          }
        }, [_vm._v("\n            Total tasks: "), _c('b', [_vm._v(_vm._s(props.rowData.totalTasks))])])], 1), _vm._v(" "), _c('div', {
          staticStyle: {
            "padding-top": "1em"
          }
        }, [_c('el-button', {
          attrs: {
            "icon": "fa fa-map-marker"
          },
          on: {
            "click": function($event) {
              return _vm.toggleMap(props.rowData.site.siteId)
            }
          }
        }, [_vm._v("Map")]), _vm._v(" \n          "), _c('i', [(props.rowData.site.address) ? _c('span', [_vm._v(_vm._s(props.rowData.site.address))]) : _vm._e(), _vm._v(" "), (props.rowData.site.postCode) ? _c('span', [_vm._v(", " + _vm._s(props.rowData.site.postCode))]) : _vm._e(), _vm._v(" "), (props.rowData.site.subdistrict) ? _c('span', [_vm._v(", " + _vm._s(props.rowData.site.subdistrict))]) : _vm._e(), _vm._v(" "), (props.rowData.site.district) ? _c('span', [_vm._v(", " + _vm._s(props.rowData.site.district))]) : _vm._e(), _vm._v(" "), (props.rowData.site.state) ? _c('span', [_vm._v(", " + _vm._s(props.rowData.site.state))]) : _vm._e(), _vm._v(" "), (props.rowData.site.country) ? _c('span', [_vm._v(", " + _vm._s(props.rowData.site.country))]) : _vm._e()]), _vm._v(" "), (_vm.showMap(props.rowData.site.siteId)) ? _c('google-map', {
          attrs: {
            "lat": props.rowData.site.latitude,
            "lng": props.rowData.site.longitude,
            "zoom": 18
          }
        }) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "clearfix"
        }, [_c('el-row', [_c('el-col', {
          attrs: {
            "align": "center",
            "sm": 22,
            "md": 10,
            "lg": 8
          }
        }, [_vm._v("\n                 "), (props.rowData.organisation) ? _c('span', [_vm._v("Org: "), _c('b', [_vm._v(_vm._s(props.rowData.organisation.name))])]) : _vm._e()]), _vm._v(" "), _c('el-col', {
          attrs: {
            "align": "center",
            "sm": 24,
            "md": 12,
            "lg": 8
          }
        }, [_vm._v("\n                 "), (props.rowData.contact && props.rowData.contact.name) ? _c('span', [_vm._v("Assigned: "), _c('b', [_vm._v(_vm._s(props.rowData.contact.name))])]) : _vm._e()]), _vm._v(" "), (props.rowData.started_at) ? _c('el-col', {
          attrs: {
            "align": "center",
            "sm": 24,
            "md": 12,
            "lg": 8
          }
        }, [_vm._v("\n                Started: "), _c('b', [_vm._v(_vm._s(_vm.formatFriendlyDate(props.rowData.started_at)))])]) : _c('el-col', {
          attrs: {
            "align": "center",
            "sm": 24,
            "md": 12,
            "lg": 6
          }
        }, [(_vm.isSiteManager && parseFloat(props.rowData.percentComplete) === 0) ? _c('div', [_c('el-alert', {
          attrs: {
            "type": "info",
            "title": "You only delete before starting workflow.",
            "show-icon": "",
            "closable": false
          }
        }, [_c('el-button', {
          attrs: {
            "type": "danger",
            "circle": "",
            "size": "mini",
            "icon": "fa fa-trash-alt"
          },
          on: {
            "click": function($event) {
              return _vm.onDelete(props.rowData)
            }
          }
        })], 1)], 1) : _vm._e()])], 1)], 1)], 1)], 1)]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f40bbfb2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/workflow/site/SiteWorkflow.vue
// module id = 1739
// module chunks = 0